// extracted by mini-css-extract-plugin
export var borderRadius = "_9v-4";
export var large = "_9v-3";
export var logoContainer = "_9v-0";
export var nameLogo = "_9v-2";
export var small = "_9v-1";